import React, {useEffect, useState, useRef, useContext} from "react";
import AmChartSimpleBar from '../../../components/AmChartSimpleBar';
import SelectionTool from '../../../components/SelectionTool';

export default function RealEstateLeasesTopTwenty({onClick}){

	const [chartData, setChartData] = useState([]);
	const [loaded, setLoaded] = useState("false");
	const [selectedCategoryType, setSelectedCategoryType] = useState({});
	
	useEffect(() => {
		loadChartData();
		setLoaded("true");
	}, [loaded]);
	
	const loadChartData = () => {
	
		let tempTopTen = [
			{label:"London HQ", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"New York HQ", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Singapore HQ", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"London: Curzon St", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Washington D.C.", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Denver", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Atlanta", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Manchester", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Glasgow", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Berlin", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Berlin Airport", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"London: Mayfair", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Heathrow Airport", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Belfast", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Madrid", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Shanghai", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Hong Kong", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Durban", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Cape Town", value:Math.round(Math.random()*1000), color:"E81E63"},
			{label:"Paris", value:Math.round(Math.random()*1000), color:"E81E63"}
		];
		
		setChartData(tempTopTen);
		
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 50px)",
		flexDirection:"column",
		alignItems:"center",
		//justifyContent:"space-around",
		padding:"10px",
		paddingTop:"0px",
		backgroundColor:"white",
		borderRadius:"6px",
		marginLeft:"20px",
		marginTop:"20px"
	};
	
	const chartProps = {
    fontSize:"14px",
    showScrollbar:false,
    showScrollbarY:false,
    showCursor:true,
    showLegend:false,
    marginLeft:0
	};
	
	const optionValues = [
		{id:"1", name:"Leased Area Sqm"},
		{id:"2", name:"Capacity"},
		{id:"3", name:"Headcount"},
		{id:"4", name:"Leased Area"},
		{id:"5", name:"Asset Breakdowns"},
		{id:"6", name:"Total Cost"},
		{id:"7", name:"HR Issues"},
		{id:"8", name:"Carbon Emissions"},
	];
	
	
		
	return (
		<div style={thisContainer}>
			
			<AmChartSimpleBar
				chartId="portfoliohome_barchart1"
				width="100%"
				height="400px"
				props={chartProps}
				chartData={chartData}
				categoryKey="label"
				valueKey="value"
				color="orange"
				onClick={onClick}
			>
			</AmChartSimpleBar>
			<SelectionTool
					title="Showing"
					value="Area"
					values={optionValues}
					dataLoad={loadChartData}
				>
				</SelectionTool>
				
		</div>
		
	);
}